<template>
    <div>
        <v-card elevation="0">
            <v-card color="#33675E" elevation="0" height="100px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-note-search-outline</v-icon>
                    &nbsp;Postings Browser
                </v-card-title>
            </v-card>
            <v-card-text>
                <Manager />
            </v-card-text>
        </v-card>
        <iframe name="hiddenFrame" hidden></iframe>
    </div>
</template>
<script>
import Manager from "../../../components/Admin/PostingsBrowser/Manager.vue"
export default {
    components: {
        Manager
    },
}
</script>